export const SELECT_FORM_INITIAL_VALUES = { selectType: [], selectForm: [] };
